import React from 'react';
import styles from './index.module.scss';
import useLinksData from './components/linksData';
import Links from './components/Links';
import LeftSection from './components/LeftSection';
import BottomSection from './components/BottomSection';
import MobileLinks from './components/MobileLinks';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';
import Image from '@/src/shared/components/Image';

interface Props {
  hasScrollToTop?: boolean;
}

const Footer = ({ hasScrollToTop }: Props) => {
  const isMobile = useIsMobile();
  const linksData = useLinksData();

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.topSection}>
        <LeftSection />

        <div className={styles.rightSection}>
          {linksData.map((link) =>
            isMobile ? (
              <MobileLinks
                title={link.title}
                links={link.links}
                key={link.title}
              />
            ) : (
              <Links title={link.title} links={link.links} key={link.title} />
            )
          )}
        </div>
      </div>

      <BottomSection />

      {hasScrollToTop && (
        <div className={styles.footerButton} onClick={handleScrollToTop}>
          <Image
            width="14"
            height="18"
            src="/images/landing/footer/icons-8-right.svg"
            alt="arrow"
          />
        </div>
      )}
    </footer>
  );
};

export default Footer;
